// extracted by mini-css-extract-plugin
export default {"container":"CardOfAspect_container__G6vTA","icon":"CardOfAspect_icon__4KBvM"};